import cx from 'classnames';
import {useSelector} from 'react-redux';
import {CheckmarkIcon} from '~library/svg/CheckmarkIcon';
import {Button} from '~library/atoms/Button';
import {selectIsPreviewMode} from '~/SignUpSheets/reducers/sheet/selectors';
import {white, charcoal} from '~libSass/base/_exports.sass';

export const SignUpButton = ({toggleSelected, slot, isSelected, expired}) => {
  const isPreviewMode = useSelector(selectIsPreviewMode);

  return (
    <Button
      variant="primary"
      onClick={() => toggleSelected(slot)}
      size="small"
      className={cx('volunteer-signup-row__sign-up-btn', {
        'volunteer-signup-row__sign-up-btn--selected': isSelected,
        'volunteer-signup-row__sign-up-btn--expired': expired,
      })}
      data-qa-id="sign-up-btn"
      disabled={isPreviewMode}
    >
      {isSelected ? (
        <>
          <CheckmarkIcon ratio={0.5} color={isSelected ? white : charcoal} /> Selected
        </>
      ) : (
        'Sign up'
      )}
    </Button>
  );
};
